import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Tab, Form, Button, Alert, ProgressBar, Card, Modal } from 'react-bootstrap';
import { 
  FaChevronRight, FaCloud, FaDatabase, FaDollarSign, 
  FaShieldAlt, FaShoppingBag, FaTools, FaCheck,
  FaLightbulb, FaRocket, FaUserTie, FaStar, FaQuoteRight,
  FaHeartbeat,
  FaCodeBranch,
  FaGlobeAsia,
  FaBookMedical,
 
} from 'react-icons/fa';
import logo from "../images/logo.png";
export default function TechSolutionsPage() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('enterprise');
  const [showContactForm, setShowContactForm] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
    
    // Add scroll animation for elements
    const handleScroll = () => {
      const elements = document.querySelectorAll('.scroll-animation');
      elements.forEach(element => {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight - 100) {
          element.classList.add('visible');
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const enterpriseSolutions = [
    {
      title: "Digital Transformation",
      icon: <FaRocket className="text-primary" size={40} />,
      description: "Revolutionize your business processes with cutting-edge digital technologies with AI-Enhanced solutions, Quantum Computing , Blockchain Integration, Cyber Intelligence for security  that drive efficiency and growth.",
      color: "primary"
    },
    {
      title: "Cloud Migration",
      icon: <FaCloud className="text-info" size={40} />,
      description: "Seamlessly transition your infrastructure, Platform, Software as a service  to cloud platforms like (Aws, Google, Azure , Digital Ocean, IBM , Oracle with our expert migration services. We Migrate a Web Apps , Mobile Apps, Quantum applications, Ai-Agents, LLM models , Geo-Insights Models and more .... ",
      color: "info"
    },
    {
      title: " Real Time Data Analytics",
      icon: <FaDatabase className="text-success" size={40} />,
      description: "Unlock valuable insights from your data with advanced analytics solutions that inform strategic decisions. We offer a wide range of insights solutions for Energy Sector, Environmental , Cloud technologies, E-commerce, Health , Finance, Block Chain, Desktop apps, hybrid/Cross Platform apps & More .....",
      color: "success"
    },
    {
      title: "Cyber Security",
      icon: <FaShieldAlt className="text-danger" size={40} />,
      description: "Protect your digital assets with our comprehensive security solutions designed to tackle evolving threats.",
      color: "danger"
    }
  ];

  const industrySolutions = [
    {
      title: "Healthcare",
      icon: <FaHeartbeat className="text-primary" size={40} />,
      description: "Specialized solutions for healthcare providers that enhance patient care and operational efficiency.",
      color: "primary"
    },
    {
      title: "Finance",
      icon: <FaDollarSign className="text-success" size={40} />,
      description: "Secure and compliant financial technology solutions that streamline transactions and reporting.",
      color: "success"
    },
    {
      title: "Retail",
      icon: <FaShoppingBag className="text-info" size={40} />,
      description: "Omnichannel retail solutions that deliver exceptional customer experiences and drive sales.",
      color: "info"
    },
    {
      title: "Manufacturing",
      icon: <FaTools className="text-warning" size={40} />,
      description: "Smart manufacturing solutions that optimize production processes and supply chain management.",
      color: "warning"
    },
    {
      title:"Technology",
      icon :<FaCodeBranch className='text-dark' size={40}/>,
      description:"Integrating Intelligence models with advance quantum computing algorithms",
      color:"success",
      
    },
    {
      title:"Energy Sector",
      icon :<FaLightbulb className='text-dark' size={40}/>,
      description:"Integrating Intelligence models with advance quantum computing algorithms",
      color:"info", 
    },
    {
      title:"Geology & GeoPhysics",
      icon :<FaGlobeAsia className='text-dark' size={40}/>,
      description:"Integrating Intelligence models with advance quantum computing algorithms",
      color:"primary",
    },
    {
      title:"Science & Research",
      icon :<FaBookMedical className='text-dark' size={40}/>,
      description:"Integrating Intelligence models with advance quantum computing algorithms",
      color:"secondary",
    }
  ];

  const testimonials = [
    {
      name: "Jennifer Smith",
      position: "CTO, Global Health Inc.",
      content: "Working with this team has been transformative for our organization. Their cloud migration strategy reduced our operational costs by 40% while improving system reliability.",
      rating: 5
    },
    {
      name: "Michael Rodriguez",
      position: "CEO, FinTech Solutions",
      content: "Their cybersecurity solutions have given us peace of mind. The team's expertise and proactive approach have prevented several potential incidents.",
      rating: 5
    },
    {
      name: "Sarah Johnson",
      position: "IT Director, Retail Chain",
      content: "The data analytics platform they implemented has revolutionized how we make decisions. We now have real-time insights that have directly increased our revenue.",
      rating: 4
    }
  ];

  // Contact form component with multi-step process
  const ConsultationRequestForm = () => {
    const [step, setStep] = useState(1);
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
      // Personal Info
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      phone: '',
      
      // Project Details
      projectType: '',
      industry: '',
      
      // Timeline & Budget
      timeline: '',
      budget: '',
      
      // Description
      description: ''
    });
    
    const validateCurrentStep = () => {
      switch(step) {
        case 1: // Personal Info
          if (!formData.firstName || !formData.lastName || !formData.email) {
            setError('Please fill out all required fields');
            return false;
          }
          if (!formData.email.includes('@')) {
            setError('Please enter a valid email address');
            return false;
          }
          break;
        case 2: // Project Details
          if (!formData.projectType || !formData.industry) {
            setError('Please select a project type and industry');
            return false;
          }
          break;
        case 3: // Timeline & Budget
          if (!formData.timeline || !formData.budget) {
            setError('Please provide timeline and budget information');
            return false;
          }
          break;
        case 4: // Description
          if (!formData.description || formData.description.trim().length < 10) {
            setError('Please provide a detailed project description (minimum 10 characters)');
            return false;
          }
          break;
        default:
          return true;
      }
      return true;
    };
    
    const handleNext = () => {
      if (validateCurrentStep()) {
        setError(null);
        setStep(step + 1);
      }
    };
    
    const handlePrevious = () => {
      setError(null);
      setStep(step - 1);
    };
    
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
      // Clear error when user is typing
      if (error) setError(null);
    };
    
    const handleSubmit = (e) => {
      e.preventDefault();
      if (validateCurrentStep()) {
        setIsSubmitting(true);
        
        // Simulate form submission
        setTimeout(() => {
          try {
            // In a real application, you would send the formData to your server here
            console.log('Form submitted successfully:', formData);
            
            // Reset form
            setFormData({
              firstName: '', lastName: '', email: '', company: '', phone: '',
              projectType: '', industry: '', timeline: '', budget: '', description: ''
            });
            setStep(1);
            setShowContactForm(false);
            setIsSubmitting(false);
          } catch (err) {
            setError('There was an error submitting your request. Please try again later.');
            setIsSubmitting(false);
          }
        }, 1500);
      }
    };
    
    const steps = ["Personal Info", "Project Details", "Timeline & Budget", "Description"];
    
    return (
      <div className="form-container bg-white rounded-lg shadow-lg p-4 p-md-5">
        <h2 className="text-center fw-bold text-primary mb-4">Request a Consultation</h2>
        
        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}
        
        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            {steps.map((stepName, idx) => (
              <span 
                key={idx} 
                className={`fw-medium small ${step === idx + 1 ? 'text-primary' : 'text-muted'}`}
              >
                {stepName}
              </span>
            ))}
          </div>
          <ProgressBar 
            now={(step / steps.length) * 100} 
            variant="primary" 
            className="mb-4" 
            style={{height: "8px"}}
          />
        </div>
        
        <Form onSubmit={step === 4 ? handleSubmit : (e) => e.preventDefault()}>
          {step === 1 && (
            <div className="fade-in">
              <h3 className="h5 fw-bold mb-3">Step 1: Personal Info</h3>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      className="form-control-lg"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      className="form-control-lg"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-control-lg"
                />
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          )}
          
          {step === 2 && (
            <div className="fade-in">
              <h3 className="h5 fw-bold mb-3">Step 2: Project Details</h3>
              <Form.Group className="mb-4">
                <Form.Label>Project Type <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="projectType"
                  value={formData.projectType}
                  onChange={handleChange}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select a project type</option>
                  <option value="digital-transformation">Digital Transformation</option>
                  <option value="cloud-migration">Cloud Migration</option>
                  <option value="data-analytics">Data Analytics</option>
                  <option value="cyber-security">Cyber Security</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Industry <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select your industry</option>
                  <option value="healthcare">Healthcare</option>
                  <option value="finance">Finance</option>
                  <option value="retail">Retail</option>
                  <option value="manufacturing">Manufacturing</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Form.Group>
            </div>
          )}
          
          {step === 3 && (
            <div className="fade-in">
              <h3 className="h5 fw-bold mb-3">Step 3: Timeline & Budget</h3>
              <Form.Group className="mb-4">
                <Form.Label>Project Timeline <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select a timeline</option>
                  <option value="immediately">Immediately</option>
                  <option value="1-3-months">1-3 months</option>
                  <option value="3-6-months">3-6 months</option>
                  <option value="6-12-months">6-12 months</option>
                  <option value="not-sure">Not sure yet</option>
                </Form.Select>
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Budget Range <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select a budget range</option>
                  <option value="under-1k">Under $1000</option>
                  <option value="1k-5k">$1000 - $5000</option>
                  <option value="10k-10k">$10,000 - $20,000</option>
                  <option value="50k-plus">$50,000+</option>
                  <option value="not-sure">Not sure yet</option>
                </Form.Select>
              </Form.Group>
            </div>
          )}
          
          {step === 4 && (
            <div className="fade-in">
              <h3 className="h5 fw-bold mb-3">Step 4: Project Description</h3>
              <Form.Group className="mb-3">
                <Form.Label>Project Description <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows={5}
                  placeholder="Please provide details about your project requirements"
                  required
                  className="form-control-lg"
                />
              </Form.Group>
            </div>
          )}
          
          <div className="d-flex justify-content-between mt-4">
            {step > 1 && (
              <Button 
                variant="outline-secondary" 
                onClick={handlePrevious}
                disabled={isSubmitting}
                className="px-4 py-2"
                size="lg"
              >
                Previous
              </Button>
            )}
            
            {step < 4 ? (
              <Button 
                variant="primary" 
                onClick={handleNext}
                className={`${step > 1 ? 'ms-auto' : ''} px-4 py-2`}
                size="lg"
              >
                Next <FaChevronRight className="ms-1" />
              </Button>
            ) : (
              <Button 
                type="submit" 
                variant="success" 
                className="ms-auto px-4 py-2 d-flex align-items-center"
                disabled={isSubmitting}
                size="lg"
              >
                {isSubmitting ? 'Submitting...' : 'Submit Request'} {!isSubmitting && <FaChevronRight className="ms-2" />}
              </Button>
            )}
          </div>
        </Form>
      </div>
    );
  };

  return (
    <div className="tech-solutions-page">
      {/* Header/Navbar would go here */}
      
      {/* Hero Section */}
      <section className={`hero-sectionn py-5 ${isVisible ? 'visible' : ''}`}>
        <div className="position-absolute top-0 start-0 w-100 h-100 hero-overlay"></div>
        <Container className="py-5 position-relative">
          <Row className="align-items-center py-5">
            <Col lg={7} className="mb-5 mb-lg-0 text-center text-lg-start">
              <div className="mb-4 d-inline-block badge bg-primary p-2 rounded-pill">
                Leading Tech Solutions Provider
              </div>
              <h1 className="display-3 fw-bold text-white mb-3 hero-title">
                Complete Technology Solutions for Modern Enterprises
              </h1>
              <p className="lead text-white-75 mb-5 hero-subtitle">
                Driving innovation and digital transformation across industries with cutting-edge technology solutions that deliver real business value.
              </p>
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                <Button 
                  variant="primary"
                  size="lg" 
                  className="fw-bold px-4 py-3 d-flex align-items-center justify-content-center"
                  onClick={() => setShowContactForm(true)}
                >
                  Schedule a Consultation <FaChevronRight className="ms-2" />
                </Button>
                <Button 
                  variant="outline-light"
                  size="lg" 
                  href='/studio_page'
                  className="fw-bold px-4 py-3"
                >
                  Continue with Studio
                </Button>
              </div>
            </Col>
            <Col lg={5} className="d-flex justify-content-center align-items-center">
              <div className="hero-animation">
                <div className="hero-sphere"></div>
                <div className="hero-card">
                  <div className="tech-icon">
                    <img src={logo} alt="logo" className="img-fluid" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="stats-section py-4 bg-white">
        <Container>
          <Row className="text-center stats-counter justify-content-center">
            <Col xs={6} md={3} className="my-3">
              <div className="stats-item scroll-animation">
                <div className="h2 fw-bold text-primary mb-1 counter">55+</div>
                <p className="mb-0 text-muted">Enterprise Projects</p>
              </div>
            </Col>
            <Col xs={6} md={3} className="my-3">
              <div className="stats-item scroll-animation">
                <div className="h2 fw-bold text-primary mb-1 counter">11+</div>
                <p className="mb-0 text-muted">Years Experience</p>
              </div>
            </Col>
            <Col xs={6} md={3} className="my-3">
              <div className="stats-item scroll-animation">
                <div className="h2 fw-bold text-primary mb-1 counter">89%</div>
                <p className="mb-0 text-muted">Client Satisfaction</p>
              </div>
            </Col>
            <Col xs={6} md={3} className="my-3">
              <div className="stats-item scroll-animation">
                <div className="h2 fw-bold text-primary mb-1 counter">24/7</div>
                <p className="mb-0 text-muted">Technical Support</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Solutions Tabs Section */}
      <section className="solutions-section py-5">
        <Container className="py-4">
          <div className="text-center mb-5 scroll-animation">
            <span className="badge bg-primary-subtle text-primary p-2 mb-3 rounded-pill fw-semibold">Our Services</span>
            <h2 className="display-5 fw-bold mb-3">Comprehensive Solutions</h2>
            <p className="lead text-muted mx-auto" style={{maxWidth: "700px"}}>
              Tailored technology services to drive innovation and efficiency for your business
            </p>
          </div>

          <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <div className="mb-5">
              <Nav className="nav-tabs-custom justify-content-center">
                <Nav.Item>
                  <Nav.Link 
                    eventKey="enterprise" 
                    className={`px-4 py-3 fw-semibold rounded-top ${activeTab === 'enterprise' ? 'active' : ''}`}
                  >
                    Enterprise Solutions
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link 
                    eventKey="industry" 
                    className={`px-4 py-3 fw-semibold rounded-top ${activeTab === 'industry' ? 'active' : ''}`}
                  >
                    Industry Solutions
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>

            <Tab.Content>
              <Tab.Pane eventKey="enterprise">
                <Row className="g-4">
                  {enterpriseSolutions.map((solution, index) => (
                    <Col key={index} md={6} lg={3}>
                      <Card className="h-100 solution-card scroll-animation border-0 shadow-sm hover-shadow">
                        <Card.Body className="p-4 text-center">
                          <div className={`solution-icon icon-${solution.color} mx-auto mb-4 d-flex align-items-center justify-content-center`}>
                            {solution.icon}
                          </div>
                          <Card.Title className="h4 fw-bold mb-3">{solution.title}</Card.Title>
                          <Card.Text className="text-muted mb-4">{solution.description}</Card.Text>
                          <Button variant={`outline-${solution.color}`} className="px-4">
                            Learn More <FaChevronRight className="ms-1" size={12} />
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="industry">
                <Row className="g-4">
                  {industrySolutions.map((solution, index) => (
                    <Col key={index} md={6} lg={3}>
                      <Card className="h-100 solution-card scroll-animation border-0 shadow-sm hover-shadow">
                        <Card.Body className="p-4 text-center">
                          <div className={`solution-icon icon-${solution.color} mx-auto mb-4 d-flex align-items-center justify-content-center`}>
                            {solution.icon}
                          </div>
                          <Card.Title className="h4 fw-bold mb-3">{solution.title}</Card.Title>
                          <Card.Text className="text-muted mb-4">{solution.description}</Card.Text>
                          <Button variant={`outline-${solution.color}`} className="px-4">
                            Learn More <FaChevronRight className="ms-1" size={12} />
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Container>
      </section>

      {/* Process Section */}
      <section className="process-section py-5 bg-light">
        <Container className="py-4">
          <div className="text-center mb-5 scroll-animation">
            <span className="badge bg-primary-subtle text-primary p-2 mb-3 rounded-pill fw-semibold">Our Process</span>
            <h2 className="display-5 fw-bold mb-3">How We Work</h2>
            <p className="lead text-muted mx-auto" style={{maxWidth: "700px"}}>
              Our structured approach ensures delivery of high-quality solutions that meet your business needs
            </p>
          </div>

          <Row className="g-4 justify-content-center">
            {[
              {
                title: "Consultation & Analysis",
                description: "We start by understanding your business challenges and objectives through in-depth consultation.",
                icon: <FaUserTie size={28} />,
                color: "primary"
              },
              {
                title: "Strategic Planning",
                description: "Our experts develop a tailored strategy and solution architecture aligned with your business goals.",
                icon: <FaLightbulb size={28} />,
                color: "info"
              },
              {
                title: "Implementation",
                description: "We implement the solution using industry best practices and rigorous quality control.",
                icon: <FaTools size={28} />,
                color: "warning"
              },
              {
                title: "Ongoing Support",
                description: "We provide continuous support and optimization to ensure long-term success.",
                icon: <FaRocket size={28} />,
                color: "success"
              }
            ].map((step, index) => (
              <Col key={index} md={6} lg={3}>
                <div className="process-card scroll-animation text-center">
                  <div className="process-step">
                    <div className={`step-number bg-${step.color}`}>
                      {index + 1}
                    </div>
                    <div className={`step-icon bg-${step.color}-subtle text-${step.color}`}>
                      {step.icon}
                    </div>
                  </div>
                  <h3 className="h4 fw-bold mt-4 mb-3">{step.title}</h3>
                  <p className="text-muted">{step.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="features-section py-5">
        <Container className="py-4">
          <div className="text-center mb-5 scroll-animation">
            <span className="badge bg-primary-subtle text-primary p-2 mb-3 rounded-pill fw-semibold">Why Choose Us</span>
            <h2 className="display-5 fw-bold mb-3">Our Competitive Advantage</h2>
            <p className="lead text-muted mx-auto" style={{maxWidth: "700px"}}>
              What sets us apart from other technology solution providers
            </p>
          </div>

          <Row className="g-4">
            {[
              {
                title: "Expert Consultation",
                description: "Our team of certified experts provides strategic guidance tailored to your business goals.",
                icon: <FaUserTie size={24} />,
              },
              {
                title: "End-to-End Solutions",
                description: "From planning to implementation and support, we handle every aspect of your technology needs.",
                icon: <FaRocket size={24} />,
              },
              {
                title: "Innovation Focus",
                description: "We stay at the forefront of technology to deliver cutting-edge solutions that drive competitive advantage.",
                icon: <FaLightbulb size={24} />,
              }
            ].map((feature, index) => (
              <Col key={index} md={4}>
                <Card className="h-100 border-0 shadow-sm hover-shadow scroll-animation">
                  <Card.Body className="p-4">
                    <div className="feature-icon mb-4">
                      <div className="icon-circle bg-primary-subtle text-primary">
                        {feature.icon}
                      </div>
                    </div>
                    <Card.Title className="h4 fw-bold mb-3">{feature.title}</Card.Title>
                    <Card.Text className="text-muted mb-0">{feature.description}</Card.Text>
                  </Card.Body>
                  <Card.Footer className="bg-transparent border-0 pt-0 pb-4 px-4">
                    <div className="text-primary fw-semibold">
                      <div className="feature-benefits">
                        <div className="benefit-item">
                          <FaCheck size={14} className="me-2" /> 
                          <span>Industry expertise</span>
                        </div>
                        <div className="benefit-item">
                          <FaCheck size={14} className="me-2" /> 
                          <span>Customized approach</span>
                        </div>
                        <div className="benefit-item">
                          <FaCheck size={14} className="me-2" /> 
                          <span>Measurable results</span>
                        </div>
                      </div>
                    </div>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section py-5 bg-light">
        <Container className="py-4">
          <div className="text-center mb-5 scroll-animation">
            <span className="badge bg-primary-subtle text-primary p-2 mb-3 rounded-pill fw-semibold">Client Success</span>
            <h2 className="display-5 fw-bold mb-3">What Our Clients Say</h2>
            <p className="lead text-muted mx-auto" style={{maxWidth: "700px"}}>
              Don't just take our word for it - hear from our satisfied clients
            </p>
          </div>

          <Row className="g-4 justify-content-center">
            {testimonials.map((testimonial, index) => (
              <Col key={index} md={6} lg={4}>
                <Card className="h-100 border-0 shadow-sm testimonial-card scroll-animation">
                  <Card.Body className="p-4 position-relative">
                    <div className="quote-icon position-absolute text-primary opacity-25">
                      <FaQuoteRight size={32} />
                    </div>
                    <div className="mb-4">
                      <div className="d-flex mb-3">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <FaStar key={i} className="text-warning me-1" />
                        ))}
                      </div>
                      <Card.Text className="fst-italic mb-4">"{testimonial.content}"</Card.Text>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="testimonial-avatar me-3">
                        <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{width: "50px", height: "50px"}}>
                          {testimonial.name.split(' ').map(n => n[0]).join('')}
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-1 fw-bold">{testimonial.name}</h5>
                        <p className="text-muted small mb-0">{testimonial.position}</p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section py-5 bg-primary text-white">
        <Container className="py-4">
          <Row className="align-items-center">
            <Col lg={8} className="mb-4 mb-lg-0">
              <div className="scroll-animation">
                <h2 className="display-5 fw-bold mb-3">Ready to Transform Your Business?</h2>
                <p className="lead mb-0">
                  Schedule a consultation with our experts to discuss your technology needs and goals.
                </p>
              </div>
            </Col>
            <Col lg={4} className="text-lg-end">
              <div className="scroll-animation">
                <Button 
                  variant="light" 
                  size="lg" 
                  className="fw-bold px-4 py-3 d-inline-flex align-items-center"
                  onClick={() => setShowContactForm(true)}
                >
                  Get Started Now <FaChevronRight className="ms-2" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    

      {/* Contact Form Modal */}
      <Modal 
        show={showContactForm} 
        onHide={() => setShowContactForm(false)}
        size="lg"
        centered
        className="consultation-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
        </Modal.Header>
        <Modal.Body className="px-4 py-0">
          <ConsultationRequestForm />
        </Modal.Body>
      </Modal>

      {/* Custom CSS would go in a separate file */}
      <style jsx>{`
        /* Hero Section */
        .hero-sectionn {
          background: linear-gradient(135deg,rgb(0, 0, 0) 30%,rgb(174, 246, 255) 80%);
          min-height: 600px;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
        }
        
        .hero-overlay {
          opacity: 0.8;
        }
        
        .hero-title, .hero-subtitle {
          position: relative;
          transition: all 0.5s ease;
          transform: translateY(30px);
          opacity: 0;
        }
        
        .visible .hero-title {
          transform: translateY(0);
          opacity: 1;
        }
        
        .visible .hero-subtitle {
          transform: translateY(0);
          opacity: 1;
          transition-delay: 0.2s;
        }
        
        .hero-animation {
          position: relative;
          width: 300px;
          height: 300px;
        }
        
        .hero-sphere {
          position: absolute;
          width: 250px;
          height: 250px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 70%);
          animation: float 6s ease-in-out infinite;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        
        .hero-card {
          position: absolute;
          width: 100%;
          height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation: rotate 12s linear infinite;
        }
        
        // @keyframes float {
        //   0%, 100% { transform: translate(-50%, -50%) translateY(0); }
        //   50% { transform: translate(-50%, -50%) translateY(-20px); }
        // }
        
        // @keyframes rotate {
        //   0% { transform: translate(-50%, -50%) rotate(0deg); }
        //   100% { transform: translate(-50%, -50%) rotate(360deg); }
        // }
        
        /* Stats Section */
        .stats-counter .stats-item {
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.6s ease;
        }
        
        .stats-counter .stats-item.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        /* Solutions Cards */
        .solution-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }
        
        .icon-primary {
          background-color: rgba(13, 110, 253, 0.1);
        }
        
        .icon-info {
          background-color: rgba(13, 202, 240, 0.1);
        }
        
        .icon-success {
          background-color: rgba(25, 135, 84, 0.1);
        }
        
        .icon-danger {
          background-color: rgba(220, 53, 69, 0.1);
        }
        
        .icon-warning {
          background-color: rgba(255, 193, 7, 0.1);
        }
        
        .solution-card {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease;
        }
        
        .solution-card.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        .hover-shadow {
          transition: all 0.3s ease;
        }
        
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important;
        }
        
        /* Process Section */
        .process-card {
          padding: 2rem;
          position: relative;
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease;
        }
        
        .process-card.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        .process-step {
          position: relative;
          display: inline-block;
        }
        
        .step-number {
          position: absolute;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          color: white;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          right: -5px;
          top: -5px;
          z-index: 2;
        }
        
        .step-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        /* Features Section */
        .feature-icon .icon-circle {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .feature-benefits {
          margin-top: 15px;
        }
        
        .benefit-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
        }
        
        /* Testimonials Section */
        .testimonial-card {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease;
        }
        
        .testimonial-card.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        .quote-icon {
          top: 20px;
          right: 20px;
        }
        
        .testimonial-avatar .rounded-circle {
          font-size: 20px;
          font-weight: bold;
        }
        
        /* Footer Styles */
        .bg-white-10 {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        .border-white-10 {
          border-color: rgba(255, 255, 255, 0.1) !important;
        }
        
        .text-white-75 {
          color: rgba(255, 255, 255, 0.75);
        }
        
        .text-white-50 {
          color: rgba(255, 255, 255, 0.5);
        }
        
        .social-link .icon-circle {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }
        
        .social-link:hover .icon-circle {
          background-color: rgba(255, 255, 255, 0.2);
        }
        
        .footer-links .nav-link, .hover-white {
          transition: all 0.3s ease;
        }
        
        .footer-links .nav-link:hover, .hover-white:hover {
          color: #fff !important;
        }
        
        /* Animation Classes */
        .scroll-animation {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease;
        }
        
        .scroll-animation.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        /* Form styles */
        .fade-in {
          animation: fadeIn 0.5s ease-in-out;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .consultation-modal .modal-content {
          border-radius: 12px;
          overflow: hidden;
        }
        
        /* Utility classes */
        .text-primary-subtle {
          color: rgba(13, 110, 253, 0.8);
        }
        
        .bg-primary-subtle {
          background-color: rgba(13, 110, 253, 0.1);
        }
        
        .nav-tabs-custom .nav-link {
          border: none;
          color: #6c757d;
          position: relative;
          transition: all 0.3s ease;
        }
        
        .nav-tabs-custom .nav-link.active {
          color: #0d6efd;
          background-color: transparent;
          border: none;
        }
        
        .nav-tabs-custom .nav-link.active::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 3px;
          background-color: #0d6efd;
          border-radius: 3px 3px 0 0;
        }
      `}</style>
    </div>
  );
}